import { useState, useEffect } from "react";
import { Category, Product } from "src/shared/services/interfacev2";
import { getCategory, getProduct } from "src/shared/services/servicesv2";

export const useRestaurantData = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchCategories = async () => {
    try {
      const res = await getCategory()
      //  api.get(`/app/v1/pos/category?include_deleted=False&pageNumber=&pageSize=`);
      setCategories(res.data.categoryDetails);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchProducts = async () => {
    try {
      const res = await getProduct()
      // api.get("/app/v1/pos/product?is_deleted=False");
      setProducts(res.data.results);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchCategories(), fetchProducts()]).finally(() => setLoading(false));
  }, []);

  return { categories, products, loading, refetchCategories: fetchCategories, refetchProducts: fetchProducts };
};